import React, {useEffect, memo} from 'react';
import { useTranslation } from "react-i18next";
import { updateConfiguration, updateParameters, updateParameter } from '../../../../helpers/utils'
import { useSelector } from 'react-redux';
import { useForm, Controller } from 'react-hook-form'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'

export const ConductivityAdvanced = memo(props => {
    const { handleSubmit, control, setValue, getValues } = useForm({mode:"onSubmit",reValidateMode:"onSubmit"})
    const { t } = useTranslation('common')
    const editConfig = useSelector(state => state.Device.config)
    const onSubmit = values => {
  
    }

     
    useEffect(() => {
        [ 
            { name: 'ar', value: editConfig.c.ar },
            { name: 'md', value: editConfig.c.md }
          ].forEach(({ name, value }) => setValue(name, value))
        
      }, [editConfig]);
  
  
    return (
      <form onSubmit={handleSubmit(onSubmit)}>
          <Container>
              <Row className="d-none">
                <Col md="7" className="parameter-text">{t('conductivity.advanced.auto_reset')}</Col>
                <Col md="2">
                    <Controller 
                          render={({ onChange }) => (
                            <Form.Control 
                                as="input"
                                className="input-digit-big"
                                id="ar" 
                                onChange={(e) => updateParameter(editConfig, "c", "ar", e.target.value)}
                                value={getValues("ar")}
                                />
                          )} 
                          name="ar"
                          control={control}
                      />
                  </Col>
                  <Col md="3" className="parameter-description">{t('conductivity.advanced.auto_reset_unit')}</Col>
              </Row>
              <Row>
                <Col md="7" className="parameter-text">{t('conductivity.advanced.measurement_delay')}</Col>
                <Col md="2">
                <Controller 
                          render={({ onChange }) => (
                            <Form.Control 
                                as="input"
                                className="input-digit-big"
                                id="md" 
                                onChange={(e) => updateParameter(editConfig, "c", "md", e.target.value)}
                                value={getValues("md")}
                                />
                          )} 
                          name="md"
                          control={control}
                      />
                  </Col>
                  <Col md="3" className="parameter-description">{t('conductivity.advanced.mdelay_unit')}</Col>
              </Row>
     
              
            </Container>
  
  
      </form>
    )
  })